import { useEffect, useRef } from 'react';

export const useVersionCheck = (interval = 60000) => {
  const currentVersion = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        const data = await res.json();

        if (!currentVersion.current) {
          currentVersion.current = data.version;
        } else if (currentVersion.current !== data.version) {
          console.log('New version detected. Reloading...');
          window.location.reload(); // Hard reload
        }
      } catch (err) {
        console.error('Error checking app version', err);
      }
    };

    const intervalId = setInterval(checkVersion, interval);
    return () => clearInterval(intervalId);
  }, [interval]);
};
